import { SetState } from 'zustand';
import { IProduct } from '../types/types';

export interface IInvoiceCreation {
  invoiceData: any;
  invoiceRemindersData: any;
  invoiceDataToUpdate: any;
  localInvoiceServiceItems: IProduct[]
  temporaryItemsBeingSaved: any
  shouldTriggerItemsValidation: boolean
  setInitialInvoiceState: () => void;
  setInvoiceData: (data: any) => void;
  setInvoiceDataToUpdate: (data: any) => void;
  setInvoiceItemsToUpdate: (data: IProduct[]) => void;
  setInvoiceReminders: (data: any) => void;
  setIsNeedToValidateItems: (value: boolean) => void
  setTemporaryItemsBeingSaved: (data: any) => void

}

const createInvoiceCreation = (set: SetState<IInvoiceCreation>) => ({
  invoiceData: null,
  invoiceRemindersData: [],
  invoiceDataToUpdate: null,
  localInvoiceServiceItems: [],
  shouldTriggerItemsValidation: false,
  temporaryItemsBeingSaved: {},
  setInvoiceData: (invoiceData: any) => {
    set({ invoiceData });
  },
  setInvoiceItemsToUpdate: (items: IProduct[]) => {
    set({ localInvoiceServiceItems: items });
  },
  setInvoiceDataToUpdate: (invoiceDataToUpdate: any) => {
    set({ invoiceDataToUpdate });
  },
  setInitialInvoiceState: () => {
    set({ invoiceDataToUpdate: null, invoiceData: null });
  },
  setInvoiceReminders: (invoiceRemindersData: any) => {
    set({ invoiceRemindersData });
  },
  setIsNeedToValidateItems: (validate: boolean) => {
    set({ shouldTriggerItemsValidation: validate });
  },
  setTemporaryItemsBeingSaved: (items: IProduct[]) => {
    set({ temporaryItemsBeingSaved: items });
  },
});

export default createInvoiceCreation;
